import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import "bootstrap/dist/css/bootstrap.min.css"
 import "bootstrap"
import '../src/assets/styles.css'
import '../src/assets/mediaquerry.css'
import VueGtag from "vue-gtag";

const app = createApp(App);
app.use(router);
app.use(VueGtag, { config: { id: process.env.VUE_APP_GoogleAnalyticsTag }, }, router);
app.mount('#app');



